import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { FadeUp } from "../components/Reveal";
import Triskelion from "../components/Triskelion";

const field = "w-full bg-ink-2 border border-white/10 focus:border-gold outline-none px-4 py-3.5 text-sm text-ivory placeholder:text-stone-mist/50 transition-colors";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Passwords do not match");
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="pt-48 pb-32 min-h-screen" data-testid="reset-page">
      <div className="max-w-md mx-auto px-6">
        <FadeUp>
          <div className="border border-white/10 bg-ink-2/60 p-8">
            <Triskelion className="w-10 h-10 text-gold mx-auto mb-6" strokeWidth={8} />
            {done ? (
              <div className="text-center" data-testid="reset-success">
                <h1 className="font-serif text-3xl text-ivory font-light mb-4">Password updated</h1>
                <p className="text-stone-mist text-sm font-light mb-8">You can now sign in with your new password.</p>
                <Link to="/account" data-testid="reset-signin" className="inline-block bg-gold text-ink px-8 py-4 text-xs uppercase tracking-[0.25em] font-medium hover:bg-gold-glow transition-colors">
                  Sign In
                </Link>
              </div>
            ) : (
              <>
                <h1 className="font-serif text-3xl text-ivory text-center font-light mb-8">Choose a new password</h1>
                {!token ? (
                  <p className="text-stone-mist text-sm text-center" data-testid="reset-invalid">
                    This reset link is invalid. <Link to="/account" className="text-gold hover:text-gold-glow">Request a new one</Link>
                  </p>
                ) : (
                  <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
                    <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (min 8 characters)" className={field} data-testid="reset-password" />
                    <input required type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" className={field} data-testid="reset-confirm" />
                    {error && <p className="text-red-400 text-xs" data-testid="reset-error">{error}</p>}
                    <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full bg-gold text-ink py-4 text-xs uppercase tracking-[0.25em] font-medium hover:bg-gold-glow transition-colors disabled:opacity-50">
                      {loading ? "Updating..." : "Update Password"}
                    </button>
                  </form>
                )}
              </>
            )}
          </div>
        </FadeUp>
      </div>
    </main>
  );
}
